/**
 * Advanced SEO Meta Tags Enhancer
 * 
 * This script dynamically enhances meta tags for better search engine visibility
 * and provides competitive advantages over similar e-commerce sites.
 */

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Advanced SEO Meta Tags Enhancer: Initializing');
    
    // Function to generate dynamic meta description based on page content
    function enhanceMetaDescription() {
      try {
        // Get existing meta description
        let metaDescription = document.querySelector('meta[name="description"]');
        
        if (!metaDescription) {
          // Create one if it doesn't exist
          metaDescription = document.createElement('meta');
          metaDescription.setAttribute('name', 'description');
          document.head.appendChild(metaDescription);
        }
        
        let description = '';
        
        // Generate different descriptions based on page type
        if (window.location.pathname.includes('/products/')) {
          // Product page
          const productTitle = document.querySelector('.ProductMeta__Title, .Product__Title, h1');
          const productVendor = document.querySelector('.ProductMeta__Vendor, .Product__Vendor');
          const productDescription = document.querySelector('.ProductMeta__Description, .Product__Description, .rte');
          
          if (productTitle && productDescription) {
            const title = productTitle.textContent.trim();
            const vendor = productVendor ? productVendor.textContent.trim() : '';
            const desc = productDescription.textContent.trim().substring(0, 100);
            
            description = `Shop ${title} by ${vendor} at LYBSTORE. ${desc}... Free shipping available. Authentic designer products with secure checkout.`;
          }
        } else if (window.location.pathname.includes('/collections/')) {
          // Collection page
          const collectionTitle = document.querySelector('.CollectionHero__Title, .Collection__Title, h1');
          const collectionDescription = document.querySelector('.CollectionHero__Description, .Collection__Description, .rte');
          
          if (collectionTitle) {
            const title = collectionTitle.textContent.trim();
            const desc = collectionDescription ? collectionDescription.textContent.trim().substring(0, 100) : '';
            
            description = `Explore our ${title} collection at LYBSTORE. ${desc}... Discover the latest trends and exclusive designer pieces. Shop now with free shipping options.`;
          }
        } else if (window.location.pathname === '/' || window.location.pathname === '/index') {
          // Homepage
          description = 'LYBSTORE offers luxury fashion and contemporary wear from top designer brands. Discover the latest collections with worldwide shipping and secure checkout. New arrivals added daily.';
        }
        
        // Update meta description if we generated one
        if (description) {
          metaDescription.setAttribute('content', description);
          console.log('Advanced SEO Meta Tags Enhancer: Updated meta description');
        }
      } catch (e) {
        console.error('Advanced SEO Meta Tags Enhancer: Error enhancing meta description', e);
      }
    }
    
    // Function to add additional SEO meta tags
    function addAdvancedMetaTags() {
      try {
        // Add canonical URL if not present
        if (!document.querySelector('link[rel="canonical"]')) {
          const canonical = document.createElement('link');
          canonical.setAttribute('rel', 'canonical');
          canonical.setAttribute('href', window.location.href.split('?')[0]);
          document.head.appendChild(canonical);
          console.log('Advanced SEO Meta Tags Enhancer: Added canonical URL');
        }
        
        // Add mobile-friendly meta tag
        if (!document.querySelector('meta[name="viewport"]')) {
          const viewport = document.createElement('meta');
          viewport.setAttribute('name', 'viewport');
          viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=5.0');
          document.head.appendChild(viewport);
          console.log('Advanced SEO Meta Tags Enhancer: Added viewport meta tag');
        }
        
        // Add additional Open Graph tags
        const ogTags = {
          'og:site_name': 'LYBSTORE',
          'og:locale': 'en_GB',
          'og:type': window.location.pathname.includes('/products/') ? 'product' : 'website'
        };
        
        for (const [property, content] of Object.entries(ogTags)) {
          if (!document.querySelector(`meta[property="${property}"]`)) {
            const meta = document.createElement('meta');
            meta.setAttribute('property', property);
            meta.setAttribute('content', content);
            document.head.appendChild(meta);
          }
        }
        
        console.log('Advanced SEO Meta Tags Enhancer: Added Open Graph tags');
        
        // Add Twitter Card tags
        const twitterTags = {
          'twitter:card': 'summary_large_image',
          'twitter:site': '@LYBSTORE'
        };
        
        for (const [name, content] of Object.entries(twitterTags)) {
          if (!document.querySelector(`meta[name="${name}"]`)) {
            const meta = document.createElement('meta');
            meta.setAttribute('name', name);
            meta.setAttribute('content', content);
            document.head.appendChild(meta);
          }
        }
        
        console.log('Advanced SEO Meta Tags Enhancer: Added Twitter Card tags');
      } catch (e) {
        console.error('Advanced SEO Meta Tags Enhancer: Error adding advanced meta tags', e);
      }
    }
    
    // Function to add competitor-focused keywords
    function addCompetitorKeywords() {
      try {
        // Get existing keywords meta tag or create a new one
        let metaKeywords = document.querySelector('meta[name="keywords"]');
        
        if (!metaKeywords) {
          metaKeywords = document.createElement('meta');
          metaKeywords.setAttribute('name', 'keywords');
          document.head.appendChild(metaKeywords);
        }
        
        // Base keywords that compete with myTheresa, JD Sports, BTSN, Selfridges, Slam Jam, END
        let keywords = 'luxury fashion, designer brands, premium footwear, exclusive collections';
        
        // Add page-specific keywords
        if (window.location.pathname.includes('/products/')) {
          // Product page - add product-specific keywords
          const productTitle = document.querySelector('.ProductMeta__Title, .Product__Title, h1');
          const productVendor = document.querySelector('.ProductMeta__Vendor, .Product__Vendor');
          
          if (productTitle) {
            const title = productTitle.textContent.trim();
            const vendor = productVendor ? productVendor.textContent.trim() : '';
            
            keywords += `, ${vendor}, ${title}, buy ${title}, ${vendor} online, authentic ${vendor}`;
          }
        } else if (window.location.pathname.includes('/collections/')) {
          // Collection page - add collection-specific keywords
          const collectionTitle = document.querySelector('.CollectionHero__Title, .Collection__Title, h1');
          
          if (collectionTitle) {
            const title = collectionTitle.textContent.trim();
            keywords += `, ${title}, shop ${title}, designer ${title}, premium ${title}, exclusive ${title}`;
          }
        }
        
        // Add competitor comparison keywords
        keywords += ', alternative to myTheresa, better than JD Sports, luxury like Selfridges, exclusive like END';
        
        // Update meta keywords
        metaKeywords.setAttribute('content', keywords);
        console.log('Advanced SEO Meta Tags Enhancer: Added competitor-focused keywords');
      } catch (e) {
        console.error('Advanced SEO Meta Tags Enhancer: Error adding competitor keywords', e);
      }
    }
    
    // Run all enhancers
    enhanceMetaDescription();
    addAdvancedMetaTags();
    addCompetitorKeywords();
    
    console.log('Advanced SEO Meta Tags Enhancer: Initialization complete');
  });
})();
